<template>
  <div>
    <div class="title-bar title-h4">기본정보</div>
    <el-form :model="basicInfo" :rules="rules" class="mr-b25" ref="basicInfoForm" label-width="120px" label-position="top" @validate="validateForm">
      <el-row :gutter="10">
        <el-col :span="12">
          <el-form-item prop="reportTmplName">
            <span slot="label">보고서종류</span>
            <el-input v-model="popupParams.label" :disabled="true"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item prop="reportName">
            <span slot="label">보고서명</span>
            <el-input v-model="basicInfo.reportName"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-form-item prop="reportContents">
        <span slot="label">보고서 설명</span>
        <el-input placeholder="보고서 설명을 입력해 주십시오." type="textarea" :rows="3" v-model="basicInfo.reportContents"></el-input>
      </el-form-item>
      <el-row :gutter="10" v-if="periodData.length > 0">
        <el-col :span="8">
          <el-form-item prop="periodType">
            <el-select v-model="basicInfo.periodType" style="width: 100%;">
              <span slot="label">보고서타입</span>
              <el-option v-for="item in periodData" :key="item.value" :label="item.label" :value="item.value" />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="16">
          <el-form-item v-show="basicInfo.periodType === 'C'" prop="periodDate">
            <el-date-picker style="width:250px;" v-model="basicInfo.periodDate" type="daterange"
            :range-separator="defaultDateRangeOptions.rangeSeparator"
            :start-placeholder="defaultDateRangeOptions.startPlaceholder"
            :end-placeholder="defaultDateRangeOptions.endPlaceholder"
            :default-time="defaultDateRangeOptions.defaultTime"
            :picker-options="defaultDateRangeOptions.pickerOptions"
            :clearable="false" />
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <div v-show="basicInfo.periodType !== 'C'">
      <div class="title-bar title-h4">스케줄링 설정</div>
      <el-form :model="basicInfo" ref="scheduleInfoForm" label-width="120px" label-position="top" @validate="validateForm">
        <el-row :gutter="10">
          <el-col :span="8">
            <el-form-item prop="autoCreateFlag">
              <span slot="label">자동생성 여부</span>
              <el-select v-model="basicInfo.autoCreateFlag" style="width: 100%;" @change="changeAutoCreateFlag">
                <el-option label="활성" value="Y" />
                <el-option label="비활성" value="N" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="16">
            <el-form-item>
              <span slot="label">자동생성 주기</span>
              <el-row>
                <el-select v-show="monthFlag" :disabled="basicInfo.autoCreateFlag === 'N'" v-model="basicInfo.autoCreateMonth" style="width: 80px;">
                  <el-option v-for="item in MONTH" :key="item.month" :label="item.label" :value="item.value" />
                </el-select>
                <el-select v-show="monthFlag || basicInfo.periodType === 'M'" :disabled="basicInfo.autoCreateFlag === 'N'" v-model="basicInfo.autoCreateDate" style="width: 100px;">
                  <el-option v-for="i in monthendScheduleDate" :key="i" :label="i" :value="i" />
                  <el-option label="마지막 날" :value="0" />
                </el-select>
                <span v-show="(monthFlag || basicInfo.periodType === 'M') && basicInfo.autoCreateDate !== 0" :disabled="basicInfo.autoCreateFlag === 'N'">일</span>
                <el-select v-show="basicInfo.periodType === 'W'" v-model="basicInfo.autoCreateDay" :disabled="basicInfo.autoCreateFlag === 'N'" style="width: 100px;">
                  <el-option v-for="item in WEEK" :key="item.week" :label="item.label" :value="item.week" />
                </el-select>
                <el-select v-model="basicInfo.autoCreateHour" :disabled="basicInfo.autoCreateFlag === 'N'" style="width: 80px;">
                  <el-option v-for="item in TIME" :key="item.time" :label="item.label" :value="item.time" />
                </el-select>
                <span :disabled="basicInfo.autoCreateFlag === 'N'">시</span>
                <el-select v-model="basicInfo.autoCreateMinute" :disabled="basicInfo.autoCreateFlag === 'N'" style="width: 80px;">
                  <el-option v-for="item in INTERVAL_FIVE_MINUTE" :key="item.time" :label="item.label" :value="item.minute" />
                </el-select>
                <span :disabled="basicInfo.autoCreateFlag === 'N'">분</span>
              </el-row>
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item prop="reportTargetEmail">
          <span slot="label">보고서 수령 이메일</span>
          <el-input :disabled="basicInfo.autoCreateFlag === 'N'" v-model="basicInfo.reportTargetEmail"></el-input>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
import isNil from 'lodash/isNil';
import { isEmpty } from '@/utils/basic';
import { mapGetters } from 'vuex';
import moment from 'moment';
import { defaultDateRangeOptions, getDateToString } from '@/utils/date';
import { TIME, MONTH, WEEK, INTERVAL_FIVE_MINUTE } from '@/constants/date';

export default {
  name: 'WReportBasicInfoView',
  props: {
    popupParams: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      TIME,
      MONTH,
      WEEK,
      INTERVAL_FIVE_MINUTE,
      defaultDateRangeOptions,
      basicInfo: {
        autoCreateMonth: 1,
        autoCreateDate: 1,
        autoCreateDay: 0,
        autoCreateHour: 0,
        autoCreateMinute: 0,
        periodType: 'D',
        autoCreateFlag: 'N',
        periodDate: [new Date(), new Date()],
      },
      rules: {
        reportName: [
          { required: true, message: '보고서명을 입력해 주십시오.', trigger: 'blur' },
        ],
      },
      formValid: false,
      // periodTypeDatas: [
      //   { value: 'D', label: '일간' },
      //   { value: 'W', label: '주간' },
      //   { value: 'M', label: '월간' },
      //   { value: 'Q', label: '분기' },
      //   { value: 'H', label: '반기' },
      //   { value: 'Y', label: '연간' },
      //   // { value: 'C', label: '사용자 정의' },
      // ],
    };
  },
  computed: {
    monthFlag() {
      const periodType = this.basicInfo.periodType;
      return periodType === 'Y' || periodType === 'H' || periodType === 'Q';
    },
    monthendScheduleDate() {
      const autoCreateMonth = this.basicInfo.autoCreateMonth - 1;
      // moment에서 month는 0부터 시작
      return moment().months(autoCreateMonth).endOf('month').dates();
    },
    periodData() {
      return isEmpty(this.popupParams.periodDataSet) ? [] : JSON.parse(this.popupParams.periodDataSet);
    },
    ...mapGetters(['userInfo']),
  },
  methods: {
    validateForm(prop, valid) {
      this.formValid = valid;
    },
    initBasicInfo(updateFlag) {
      if (!updateFlag) {
        this.basicInfo = {
          reportTmplId: this.popupParams.reportTmplId,
          reportName: '',
          reportContents: '',
          autoCreateMonth: 1,
          autoCreateDate: 1,
          autoCreateDay: 0,
          autoCreateHour: 0,
          autoCreateMinute: 0,
          periodType: isEmpty(this.periodData) ? null : this.periodData[0].value,
          autoCreateFlag: 'N',
          reportTargetEmail: this.userInfo.email,
          periodDate: [new Date(), new Date()],
        };
      } else {
        this.basicInfo = this.popupParams.basicInfo;
      }
    },
    getReportBasicInfo() {
      const resultMap = {
        validatePromise: this.$refs.basicInfoForm.validate(),
      };
      const basicInfo = this.basicInfo;
      resultMap.reportBasicInfo = {
        reportTmplId: basicInfo.reportTmplId,
        reportName: basicInfo.reportName,
        reportContents: basicInfo.reportContents,
        periodType: basicInfo.periodType,
        autoCreateFlag: basicInfo.autoCreateFlag,
      };

      if (!isNil(this.popupParams.reportId)) {
        resultMap.reportBasicInfo.reportId = this.popupParams.reportId;
      }

      // 사용자 정의일 경우 period_conf_set 설정 필요
      if (basicInfo.periodType === 'C') {
        resultMap.reportBasicInfo.autoCreateFlag = 'N';
        const startTime = getDateToString(basicInfo.periodDate[0], 'YYYY-MM-DD 00:00:00');
        const endTime = getDateToString(basicInfo.periodDate[1], 'YYYY-MM-DD 23:59:59');
        resultMap.reportBasicInfo.periodConfSet = `${startTime},${endTime}`;
      }

      if (resultMap.reportBasicInfo.autoCreateFlag === 'Y') {
        resultMap.reportBasicInfo.reportTargetEmail = basicInfo.reportTargetEmail;
        resultMap.reportBasicInfo.autoCreateHour = basicInfo.autoCreateHour;
        resultMap.reportBasicInfo.autoCreateMinute = basicInfo.autoCreateMinute;
        if (basicInfo.periodType === 'W') {
          resultMap.reportBasicInfo.autoCreateDay = basicInfo.autoCreateDay;
        } else if (basicInfo.periodType === 'M') {
          resultMap.reportBasicInfo.autoCreateDate = basicInfo.autoCreateDate;
        } else if (basicInfo.periodType !== 'D') {
          resultMap.reportBasicInfo.autoCreateDate = basicInfo.autoCreateDate;
          resultMap.reportBasicInfo.autoCreateMonth = basicInfo.autoCreateMonth;
        }
      }

      return resultMap;
    },
    changeAutoCreateFlag(value) {
      if (value === 'Y' && isEmpty(this.basicInfo.reportTargetEmail)) {
        this.basicInfo.reportTargetEmail = this.userInfo.email;
      }
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/views/report/popup/components/ReportBasicInfoView.vue